import { render, staticRenderFns } from "./SelectAndSearch.vue?vue&type=template&id=0fc23bec&scoped=true"
import script from "./SelectAndSearch.vue?vue&type=script&lang=js"
export * from "./SelectAndSearch.vue?vue&type=script&lang=js"
import style0 from "./SelectAndSearch.vue?vue&type=style&index=0&id=0fc23bec&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fc23bec",
  null
  
)

export default component.exports